import { Checkbox as BaseCheckbox } from '#app/components/Controls/src/Checkbox.js';
import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const MobileFullscreenBackButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;

    padding: 8px;
    padding-left: 0px;
    padding-top: 0px;

    margin-bottom: 16px;

    color: ${theme.colorsV2.black};
  `}
`;

export const MobileFullscreenChildrenContainer = styled.div<{
  addMobileKeyboardPadding: boolean;
}>`
  overflow: auto;
  // Adding extra padding to the bottom to account for the mobile keyboard
  ${({ addMobileKeyboardPadding }) =>
    addMobileKeyboardPadding &&
    css`
      padding-bottom: 300px;
    `}
`;

export const DrawerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;

  > * {
    width: 100%;
  }
`;

export const DrawerActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > * + * {
    margin-top: 8px;
  }
  > * {
    width: 100%;
  }
`;

export const DrawerSubheader = styled(Text)`
  width: 100%;
  margin-bottom: 24px;

  ${({ theme }) => css`
    color: ${theme.colorsV2.gray70};
  `}
`;

export const Checkbox = styled(BaseCheckbox)`
  ${({ isToggle, theme }) => css`
    margin: 0 auto 16px 0;

    ${isToggle &&
    css`
      margin: 16px 0;
    `}

    ${theme.mediaQueries.lg} {
      margin: 0 auto 0 0;
    }

    & > div {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  `}
`;

export const ToggleLabel = styled.label`
  margin-right: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const StepProgress = styled.div`
  flex-grow: 1;
`;

export const StepProgressText = styled(Text).attrs({
  textStyle: 'text-ol-medium',
})`
  text-transform: uppercase;
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray60};
  `}
`;
